// @flow strict
import * as React from 'react'

import styles from './HeaderNavigation.module.scss'
import linkStyles from './Link.module.scss'
import Link from './Link'
import Button from '../../atoms/Button'
import MonzoLogo from '../../static/monzo-logo-white.svg'
import MenuClose from '../../static/icons/MenuClose'
import MenuHamburger from '../../static/icons/MenuHamburger'
import TrackEvents from '../../atoms/TrackEvents/TrackEvents'
import { URLS } from '../../../constants'
/*******************************************************************************
  Types
 ******************************************************************************/

type Props = {
  children?: React.ChildrenArray<React.Element<typeof Link>>,
  cta?: { href: string, text: string },
}

/*******************************************************************************
  Component
 ******************************************************************************/

const HeaderNavigation = (props: Props) => {
  const { children, cta } = props
  const [showMenu, setShowMenu] = React.useState(false)
  const toggleMobileMenuVisibility = () => setShowMenu(!showMenu)

  const menuClasses = [styles.menu, showMenu ? styles.menuVisible : ''].join(
    ' ',
  )

  const footerClasses = [
    styles.footer,
    showMenu ? styles.footerVisible : '',
  ].join(' ')

  const toggleIconClasses = [
    styles.toggleIcon,
    showMenu ? styles.toggleIconVisible : '',
  ].join(' ')

  const renderMenuIcon = showMenu ? (
    <MenuClose className={toggleIconClasses} />
  ) : (
    <MenuHamburger className={toggleIconClasses} />
  )

  return (
    <nav className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.header}>
          <a href={URLS.HOMEPAGE} aria-label="Navigate to Monzo homepage">
            <img className={styles.logo} src={MonzoLogo} alt="Monzo homepage" />
          </a>

          <button
            onClick={toggleMobileMenuVisibility}
            className={styles.toggle}
            aria-expanded={showMenu}
            aria-controls="header-navigation"
          >
            Menu
            {renderMenuIcon}
          </button>
        </div>

        <ul id="header-navigation" className={menuClasses}>
          {children !== undefined ? (
            React.Children.map(children, child => (
              <li className={styles.item} id={child.props.children}>
                {child}
              </li>
            ))
          ) : (
            <li className={linkStyles.link} />
          )}
        </ul>

        <div className={footerClasses}>
          <TrackEvents
            category="conversion"
            action="download app"
            label="header"
          >
            <Button href={(cta && cta.href) || URLS.ADJUST_BOTH_STORE}>
              {(cta && cta.text) || 'Sign up'}
            </Button>
          </TrackEvents>
        </div>
      </div>
    </nav>
  )
}

/*******************************************************************************
  Nested Components
 ******************************************************************************/

HeaderNavigation.Link = Link

export default HeaderNavigation
